export const PSObjOne = {
    lightBg : true,
    lightText : false,
    lightTextDesc : false,
    topLine : 'Capacity Building',
    headline : 'Technology and Entrepreneurship Training',
    description : 'Technology and Etrepreneurship is our key area of specilization ' + 
    'In conjunction with the Federal Ministry of Humanitarian Affairs, Disaster Management  ' +
    'and Social Development, we recently trained about 3,000 N-Power beneficiaries of ' +
    'Kaduna State',
    buttonLabel : 'More Details',
    imgStart : 'start',
    img : '../../nPowerLogo.png',
    alt: 'N Power'
}
export const PSObjTwo = {

    lightBg : false,
    lightText : true,
    lightTextDesc : true,
    topLine : 'bani bayani',
    headline : 'The Nigerian Talking Calculator App',
    description : 'This mobile app BANI BAYANI allows you to perform your basic calculations ' + 
    'in Nigerian Languages of Hausa, Igbo and Yoruba. It is one of the new products ' +
    'from our Software Developmant Partners - ybCodeLab. It is available on Adroid and IOS',
    buttonLabel : 'Download App',
    imgStart : 'end',
    img : '../../banibayaniLogo.gif',
    alt: 'Bani Bayani'
}

export const PSObjThree = {

    lightBg : true,
    lightText : false,
    lightTextDesc : true,
    topLine : 'Enterprise Solutions',
    headline : 'End-to-End IT Solutions for the Modern Enterprise',
    description : 'One of our key competencies is the deployment IT solutions for the enterprise ' + 
    'in Nigerian Languages of Hausa, Igbo and Yoruba. It is one of the new products ' +
    'from our Software Developmant Partners - ybCodeLab. It is available on Adroid and IOS',
    buttonLabel : 'More Details',
    imgStart : 'end',
    img : '../../banibayaniLogo.gif',
    alt: 'Bani Bayani'
}
